module.exports = __webpack_public_path__ + "img/01_full.5873336c.jpg";